import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { compose } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import BaseButton from "components/UI/Buttons/BaseButton";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import titleCase from "title-case";
import pluralize from "pluralize";
import { getDeleteAction } from "actions/utils";

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing.unit,
    height: 32,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
});

class ShowToolBar extends React.Component {
  handleCreate = e => {
    e.preventDefault();
    const { history, match } = this.props;
    history.push(`/${match.path.split("/")[1]}/create`);
  };

  handleUpdate = e => {
    e.preventDefault();
    const { history, match } = this.props;
    history.push(`/${match.path.split("/")[1]}/${match.params.id}/edit`);
  };

  handleDelete = e => {

    e.preventDefault();

    const { moduleName, history, match, dispatch } = this.props;
    
    const deleteAction = getDeleteAction(moduleName);

    dispatch(deleteAction(match.params.id)).then(() => {
      history.push(`/${match.path.split("/")[1]}`);
    });
  };

  handleDiscard = () => {
    this.props.history.goBack();
  };

  render() {
    const { classes, moduleName, actions } = this.props;

    const moduleTitle = titleCase(pluralize.singular(moduleName));

    return (
      <div className={classes.root}>
        <Grid container spacing={16} alignItems="center">
          <Grid item xs={12} sm={6}>
            <Typography component="h2" variant="h5">
              {`${moduleTitle} Details`}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.alignRight}>
            <BaseButton
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.handleCreate}
            >
              Create
            </BaseButton>

            {actions.edit && (
              <Button
                variant="contained"
                color="default"
                className={classes.button}
                onClick={this.handleUpdate}
              >
                Edit
              </Button>
            )}
            <Button
              variant="contained"
              color="default"
              // disabled
              className={classes.button}
              onClick={this.handleDelete}
            >
              Delete
            </Button>
            <Grid item xs={4} className={classes.alignRight}>
              <IconButton aria-label="Close" onClick={this.handleDiscard}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

ShowToolBar.defaultProps = {
  actions: {
    edit: true,
  },
};

ShowToolBar.propTypes = {
  moduleName: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    edit: PropTypes.bool,
  }),
};

export default compose(
  withRouter,
  connect(),
  withStyles(styles)
)(ShowToolBar);
